export default __webpack_public_path__ + "static/media/para_r_377_bp.79bff37b.svg";